// extracted by mini-css-extract-plugin
export default {"hidden":"classes_hidden__hGMRf"};